export default "__VITE_ASSET__KbYBu5Ze__"